export interface UuFieldConfig {
  /** Base IE field name (entrySource) */
  readonly fieldName: string;
  /** Stable identifier used to tag uploaded documents */
  readonly shareId: string;
  /** Default title for uploaded documents */
  readonly documentTitle: string;
}

const RAW_CONFIG: Array<Omit<UuFieldConfig, "shareId">> = [
  { fieldName: "universalCredit", documentTitle: "Universal Credit proof" },
  { fieldName: "pensionCredit", documentTitle: "Pension Credit proof" },
  {
    fieldName: "housingBenefitLocalAllowance",
    documentTitle: "Housing Benefit proof",
  },
  { fieldName: "childBenefit", documentTitle: "Child Benefit proof" },
  {
    fieldName: "disabilityAllowance",
    documentTitle: "Disability Benefit proof",
  },
  { fieldName: "maritalSplit", documentTitle: "Marital Split proof" },
  { fieldName: "redundancy", documentTitle: "Redunancy proof" },
  { fieldName: "deceasedOccupier", documentTitle: "Bereavement proof" },
  {
    fieldName: "changeInWorkingHours",
    documentTitle: "Drop of working hours proof",
  },
  {
    fieldName: "dropInIncomeDueToIllness",
    documentTitle: "Unable to work due to illness proof",
  },
  { fieldName: "medicalEvidence", documentTitle: "Medical Evidence proof" },
];

export const UU_FIELD_CONFIG: Record<string, UuFieldConfig> = RAW_CONFIG.reduce(
  (acc, config) => {
    const shareId = `uu-${config.fieldName}`;
    acc[config.fieldName] = { ...config, shareId };
    return acc;
  },
  {} as Record<string, UuFieldConfig>
);

export const UU_FIELD_NAMES: readonly string[] = Object.keys(UU_FIELD_CONFIG);

export const isUuFieldName = (
  fieldName: string | null | undefined
): boolean => {
  if (!fieldName) {
    return false;
  }
  return Boolean(UU_FIELD_CONFIG[fieldName]);
};

export const getUuFieldConfig = (
  fieldName: string
): UuFieldConfig | undefined => UU_FIELD_CONFIG[fieldName];
